import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyArchivePage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-2xl font-bold mb-2">개인정보 처리방침 개정 이력</h1>
          <p className="text-sm text-gray-600 mb-6">
            과거 시행되었던 개인정보 처리방침 전문을 보관합니다. 아래 버전들은 각 개정일자 전까지만 효력이 있었으며,
            현재는 효력이 없습니다. 현재 시행 중인 개인정보 처리방침은{' '}
            <Link to="/privacy" className="text-primary underline">
              개인정보 처리방침 페이지
            </Link>
            에서 확인하실 수 있습니다.
          </p>

          <div className="space-y-3">
            <details className="border rounded-lg p-4" open>
              <summary className="cursor-pointer font-semibold text-gray-800">
                제5판 (개정일자: 2026년 8월 13일 ~ 2026년 8월 13일)
              </summary>
              <p className="text-xs text-gray-500 mt-2 mb-4">
                웹사이트 이용 통계 분석을 위해 Google Analytics(GA4)를 도입한 버전입니다.
                2026년 8월 14일 개정(웹사이트 이용 통계 분석 도구를 Google Analytics(GA4)에서 Umami로 변경함에 따라 자동수집항목·위탁·국외이전 조항 및 수집 거부 방법 갱신)으로 효력을 상실했습니다.
              </p>

              <div className="space-y-6 text-sm">
                <p className="text-gray-700 leading-relaxed">
                  지호아이앤씨(이하 "회사")은 ALT Generation 서비스와 관련하여 「개인정보 보호법」 및 관계 법령에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속원활하게 처리하기 위하여 다음과 같이 개인정보 처리방침을 수립공개합니다.
                </p>

                <section>
                  <h3 className="font-bold text-base mb-2">제1조</h3>
                  <p className="text-gray-700 leading-relaxed">
                    개인정보의 처리 목적에 관한 조항은 현재 시행 중인{' '}
                    <Link to="/privacy" className="text-primary underline">개인정보 처리방침</Link>
                    {' '}제1조와 동일합니다.
                  </p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제2조 (처리하는 개인정보의 항목)</h3>
                  <p className="text-gray-700 leading-relaxed mb-2 text-xs text-gray-500">
                    이 버전은 웹사이트 이용 통계 분석 도구로 Umami가 아닌 Google Analytics(GA4)를 사용했습니다. 자동 수집 항목 중 통계 도구 관련 항목만 아래와 같이 달랐고, 나머지는 현재 시행 중인 방침 제2조와 동일합니다.
                  </p>
                  <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                    <li>Google Analytics(GA4) 방문자 식별자(쿠키) 및 웹사이트 이용 통계 정보: 방문 페이지, 클릭 이벤트, 유입 경로 등 (웹사이트 이용 통계 분석 목적)</li>
                  </ol>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제3조~제4조</h3>
                  <p className="text-gray-700 leading-relaxed">
                    개인정보의 처리 및 보유기간, 제3자 제공에 관한 조항은 현재 시행 중인{' '}
                    <Link to="/privacy" className="text-primary underline">개인정보 처리방침</Link>
                    {' '}제3조~제4조와 동일합니다.
                  </p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제5조 (개인정보 처리의 위탁)</h3>
                  <p className="text-gray-700 leading-relaxed mb-2 text-xs text-gray-500">
                    이 버전의 위탁 목록에는 Umami Software, Inc. 대신 아래와 같이 Google LLC(Google Analytics) 항목이 있었습니다. 나머지 수탁업체(AWS, 토스페이먼츠, 바로빌)는 현재 시행 중인 방침 제5조와 동일합니다.
                  </p>
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-200 text-xs mt-2">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border border-gray-200 px-3 py-2 text-left">수탁업체</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">위탁 업무</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">보유이용기간</th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-700">
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">Google LLC (Google Analytics)</td>
                          <td className="border border-gray-200 px-3 py-2">웹사이트 방문자 트래픽 및 서비스 이용 통계 분석</td>
                          <td className="border border-gray-200 px-3 py-2">Google Analytics 데이터 보관 정책에 따름</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제6조 (개인정보의 국외 이전)</h3>
                  <p className="text-gray-700 leading-relaxed mb-2 text-xs text-gray-500">
                    이 버전의 국외 이전 대상에는 Umami Software, Inc. 대신 아래와 같이 Google LLC(Google Analytics) 항목이 있었고, 수집 거부 방법도 Google Analytics 사용 중단 브라우저 부가기능을 안내했습니다. OpenAI/Google/Microsoft(AI 이미지 분석·번역) 관련 행은 현재 시행 중인 방침 제6조와 동일합니다.
                  </p>
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-200 text-xs mt-2">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border border-gray-200 px-3 py-2 text-left">이전받는 자</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">이전 항목</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">이전 국가</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">이전 시기 및 방법</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">이용목적 및 보유·이용기간</th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-700">
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">Google LLC (Google Analytics)<br />(policies.google.com/privacy)</td>
                          <td className="border border-gray-200 px-3 py-2">방문 페이지, 클릭 이벤트 등 서비스 이용 통계 정보, 기기·브라우저 식별자(쿠키)</td>
                          <td className="border border-gray-200 px-3 py-2">미국</td>
                          <td className="border border-gray-200 px-3 py-2">웹사이트/서비스 이용 시 실시간 자동 수집·전송</td>
                          <td className="border border-gray-200 px-3 py-2">웹사이트 이용 통계 분석(방문자 수, 인기 페이지, 유입 경로 파악) 목적; Google Analytics 데이터 보관 정책에 따름</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p className="text-gray-700 leading-relaxed mt-2">
                    Google Analytics를 통한 웹사이트 이용 통계 수집을 원하지 않는 경우, Google이 제공하는 &quot;Google Analytics 사용 중단 브라우저 부가기능&quot;(https://tools.google.com/dlpage/gaoptout)을 설치하여 거부할 수 있으며, 이 경우에도 서비스의 다른 기능 이용에는 영향이 없습니다.
                  </p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제7조~제13조</h3>
                  <p className="text-gray-700 leading-relaxed">
                    이용자의 권리·의무 및 행사방법, 개인정보의 파기, 안전성 확보조치, 인증 토큰 및 세션 관리, 개인정보 보호책임자, 처리방침의 변경, 권익침해 구제방법에 관한 조항은
                    현재 시행 중인{' '}
                    <Link to="/privacy" className="text-primary underline">개인정보 처리방침</Link>
                    {' '}제7조~제13조와 동일합니다.
                  </p>
                </section>

                <div className="pt-4 border-t mt-6 space-y-1">
                  <p className="text-gray-600 text-xs">공고일자: 2026년 3월 27일</p>
                  <p className="text-gray-600 text-xs">시행일자: 2026년 4월 1일</p>
                  <p className="text-gray-600 text-xs">개정일자: 2026년 7월 24일 (개인정보 처리위탁 업체에 토스페이먼츠·바로빌 추가)</p>
                  <p className="text-gray-600 text-xs">개정일자: 2026년 7월 26일 (국외 이전 조항을 위탁 조항에서 분리·신설, AWS 국내 서버 명시, 관리자 접속기록 보관기간을 2년으로 명시)</p>
                  <p className="text-gray-600 text-xs">개정일자: 2026년 8월 10일 (AI 모델 학습 관련 문구 정리, 국외이전 대상별 실제 보유기간 및 번역 처리 목적 명시, 이용자 권리별 처리기간 세분화, 인증 토큰 관련 기술적 세부사항 간소화)</p>
                  <p className="text-gray-600 text-xs">개정일자: 2026년 8월 13일 (웹사이트 이용 통계 분석을 위한 Google Analytics(GA4) 도입에 따라 자동수집항목·위탁·국외이전 조항에 관련 내용 및 수집 거부 방법 추가)</p>
                </div>
              </div>
            </details>

            <details className="border rounded-lg p-4">
              <summary className="cursor-pointer font-semibold text-gray-800">
                제4판 (개정일자: 2026년 8월 10일 ~ 2026년 8월 12일)
              </summary>
              <p className="text-xs text-gray-500 mt-2 mb-4">
                AI 모델 학습 관련 문구를 정리하고, 국외이전 대상별 실제 보유기간 및 번역 처리 목적을 명시한 버전입니다.
                2026년 8월 13일 개정(웹사이트 이용 통계 분석을 위한 Google Analytics(GA4) 도입에 따라 자동수집항목·위탁·국외이전 조항에 관련 내용 및 수집 거부 방법 추가)으로 효력을 상실했습니다.
              </p>

              <div className="space-y-6 text-sm">
                <p className="text-gray-700 leading-relaxed">
                  지호아이앤씨(이하 "회사")은 ALT Generation 서비스와 관련하여 「개인정보 보호법」 및 관계 법령에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속원활하게 처리하기 위하여 다음과 같이 개인정보 처리방침을 수립공개합니다.
                </p>

                <section>
                  <h3 className="font-bold text-base mb-2">제1조</h3>
                  <p className="text-gray-700 leading-relaxed">
                    개인정보의 처리 목적에 관한 조항은 현재 시행 중인{' '}
                    <Link to="/privacy" className="text-primary underline">개인정보 처리방침</Link>
                    {' '}제1조와 동일합니다.
                  </p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제2조 (처리하는 개인정보의 항목)</h3>
                  <p className="text-gray-700 leading-relaxed mb-2 text-xs text-gray-500">
                    이 버전은 아직 Google Analytics(GA4)를 도입하지 않아 자동 수집 항목에 GA4 관련 항목이 없었습니다.
                  </p>
                  <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                    <li>회원가입 시 필수항목: 로그인 아이디, 비밀번호(BCrypt 암호화 저장), 이름, 이메일 주소</li>
                    <li>회원가입 시 선택항목: 휴대전화번호, 회사명, 사업자번호</li>
                    <li>소셜 로그인 시 수집 항목: Google/네이버/카카오 로그인 시 각 사업자가 제공하는 이메일, 이름(또는 닉네임)</li>
                    <li>서비스 이용 시 자동 수집 항목: 접속 IP, 브라우저/OS 정보, 방문 일시, 로그인 세션 정보, ALT 텍스트 생성 이력, API 호출 기록, 크롤링 대상 URL 및 메타데이터, 컨텍스트 프로필 설정, API 인증 정보</li>
                    <li>이미지 업로드 시: 이용자가 업로드한 이미지 파일은 이용자가 직접 삭제하거나 회원 탈퇴 시 삭제됩니다. 생성된 ALT 텍스트 결과물은 이용자 삭제 요청 시 또는 탈퇴 후 1년 보존 기간 경과 후 삭제됩니다.</li>
                  </ol>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제3조~제4조</h3>
                  <p className="text-gray-700 leading-relaxed">
                    개인정보의 처리 및 보유기간, 제3자 제공에 관한 조항은 현재 시행 중인{' '}
                    <Link to="/privacy" className="text-primary underline">개인정보 처리방침</Link>
                    {' '}제3조~제4조와 동일합니다.
                  </p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제5조 (개인정보 처리의 위탁)</h3>
                  <p className="text-gray-700 leading-relaxed mb-2 text-xs text-gray-500">
                    이 버전은 아직 Google Analytics(GA4)를 도입하지 않아 위탁 목록에 Google LLC(Google Analytics) 항목이 없었습니다.
                  </p>
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-200 text-xs mt-2">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border border-gray-200 px-3 py-2 text-left">수탁업체</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">위탁 업무</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">보유이용기간</th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-700">
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">Amazon Web Services (AWS) 서울 리전</td>
                          <td className="border border-gray-200 px-3 py-2">서버 호스팅, 데이터 저장 (국내 서버 운영)</td>
                          <td className="border border-gray-200 px-3 py-2">이용계약 종료 시까지</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">토스페이먼츠(주)</td>
                          <td className="border border-gray-200 px-3 py-2">카드 결제 및 자동(정기)결제 대행, 결제 정보 처리</td>
                          <td className="border border-gray-200 px-3 py-2">회원 탈퇴 또는 위탁계약 종료 시까지 (전자상거래법에 따른 거래기록은 별도 보존기간 적용)</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">바로빌</td>
                          <td className="border border-gray-200 px-3 py-2">전자세금계산서·현금영수증 발행 대행</td>
                          <td className="border border-gray-200 px-3 py-2">관계 법령(전자상거래법 등)에 따른 보존기간까지</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제6조 (개인정보의 국외 이전)</h3>
                  <p className="text-gray-700 leading-relaxed mb-2 text-xs text-gray-500">
                    이 버전은 아직 Google Analytics(GA4)를 도입하지 않아 국외 이전 대상에 Google LLC(Google Analytics) 항목 및 그에 대한 수집 거부 방법 안내가 없었습니다.
                  </p>
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-200 text-xs mt-2">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border border-gray-200 px-3 py-2 text-left">이전받는 자</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">이전 항목</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">이전 국가</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">이전 시기 및 방법</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">이용목적 및 보유·이용기간</th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-700">
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">OpenAI, L.L.C.<br />(privacy@openai.com)</td>
                          <td className="border border-gray-200 px-3 py-2">업로드·크롤링된 이미지 및 관련 텍스트 콘텐츠</td>
                          <td className="border border-gray-200 px-3 py-2">미국</td>
                          <td className="border border-gray-200 px-3 py-2">ALT 텍스트 생성 요청 시점에 API(HTTPS 암호화 통신)로 즉시 전송</td>
                          <td className="border border-gray-200 px-3 py-2">AI 이미지 분석 및 ALT 텍스트 생성(주 엔진); OpenAI의 어뷰징 모니터링 정책에 따라 최대 30일간 보관 후 삭제(Zero Data Retention 미적용, 모델 학습에는 사용되지 않음)</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">Google LLC<br />(policies.google.com/privacy)</td>
                          <td className="border border-gray-200 px-3 py-2">업로드·크롤링된 이미지 및 관련 텍스트 콘텐츠, 캡션 번역용 텍스트</td>
                          <td className="border border-gray-200 px-3 py-2">미국</td>
                          <td className="border border-gray-200 px-3 py-2">ALT 텍스트 생성 요청 시점에 API(HTTPS 암호화 통신)로 즉시 전송</td>
                          <td className="border border-gray-200 px-3 py-2">AI 이미지 분석(보조 엔진, fallback) 및 캡션 번역(Azure Translator 장애 시 대체); Google Cloud 서비스 약관에 따라 처리되며 모델 학습에는 사용되지 않음</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">Microsoft Corporation<br />(privacy.microsoft.com)</td>
                          <td className="border border-gray-200 px-3 py-2">업로드·크롤링된 이미지 및 관련 텍스트 콘텐츠, 캡션 번역용 텍스트</td>
                          <td className="border border-gray-200 px-3 py-2">미국</td>
                          <td className="border border-gray-200 px-3 py-2">ALT 텍스트 생성 요청 시점 및 캡션 번역 시점에 API(HTTPS 암호화 통신)로 즉시 전송</td>
                          <td className="border border-gray-200 px-3 py-2">AI 이미지 분석(보조 엔진, fallback) 및 캡션 번역(Azure Translator); Microsoft의 어뷰징 모니터링 정책에 따라 최대 30일간 보관 후 삭제(Zero Data Retention 미적용, 모델 학습에는 사용되지 않음)</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p className="text-gray-700 leading-relaxed mt-2">
                    이용자는 개인정보의 국외 이전을 거부할 권리가 있으며, 개인정보 보호책임자(제11조)에게 이메일로 거부 의사를 통지할 수 있습니다. 다만 위 국외 이전은 AI 기반 ALT 텍스트 자동 생성이라는 서비스 핵심 기능의 이행에 필수적인 처리이므로, 거부 시 이미지 업로드·크롤링을 통한 AI ALT 텍스트 자동 생성 기능은 이용하실 수 없습니다(계정 자체의 이용, 수동 ALT 텍스트 입력 등 다른 기능은 계속 이용 가능합니다).
                  </p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제7조~제13조</h3>
                  <p className="text-gray-700 leading-relaxed">
                    이용자의 권리·의무 및 행사방법, 개인정보의 파기, 안전성 확보조치, 인증 토큰 및 세션 관리, 개인정보 보호책임자, 처리방침의 변경, 권익침해 구제방법에 관한 조항은
                    현재 시행 중인{' '}
                    <Link to="/privacy" className="text-primary underline">개인정보 처리방침</Link>
                    {' '}제7조~제13조와 동일합니다.
                  </p>
                </section>

                <div className="pt-4 border-t mt-6 space-y-1">
                  <p className="text-gray-600 text-xs">공고일자: 2026년 3월 27일</p>
                  <p className="text-gray-600 text-xs">시행일자: 2026년 4월 1일</p>
                  <p className="text-gray-600 text-xs">개정일자: 2026년 7월 24일 (개인정보 처리위탁 업체에 토스페이먼츠·바로빌 추가)</p>
                  <p className="text-gray-600 text-xs">개정일자: 2026년 7월 26일 (국외 이전 조항을 위탁 조항에서 분리·신설, AWS 국내 서버 명시, 관리자 접속기록 보관기간을 2년으로 명시)</p>
                  <p className="text-gray-600 text-xs">개정일자: 2026년 8월 10일 (AI 모델 학습 관련 문구 정리, 국외이전 대상별 실제 보유기간 및 번역 처리 목적 명시, 이용자 권리별 처리기간 세분화, 인증 토큰 관련 기술적 세부사항 간소화)</p>
                </div>
              </div>
            </details>

            <details className="border rounded-lg p-4">
              <summary className="cursor-pointer font-semibold text-gray-800">
                제3판 (개정일자: 2026년 7월 26일 ~ 2026년 8월 9일)
              </summary>
              <p className="text-xs text-gray-500 mt-2 mb-4">
                국외 이전 조항을 위탁 조항에서 분리·신설하고, AWS 국내 서버 운영을 명시하고, 관리자 접속기록 보관기간을 2년으로 명시한 버전입니다.
                2026년 8월 10일 개정(AI 모델 학습 관련 문구 정리, 국외이전 대상별 실제 보유기간 및 번역 처리 목적 명시, 이용자 권리별 처리기간 세분화, 인증 토큰 관련 기술적 세부사항 간소화)으로 효력을 상실했습니다.
              </p>

              <div className="space-y-6 text-sm">
                <p className="text-gray-700 leading-relaxed">
                  지호아이앤씨(이하 "회사")은 ALT Generation 서비스와 관련하여 「개인정보 보호법」 및 관계 법령에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속원활하게 처리하기 위하여 다음과 같이 개인정보 처리방침을 수립공개합니다.
                </p>

                <section>
                  <h3 className="font-bold text-base mb-2">제1조 (개인정보의 처리 목적)</h3>
                  <p className="text-gray-700 leading-relaxed">
                    회원 가입 및 관리, 서비스 제공(ALT 텍스트 생성, API 제공, 요금 결제·정산), 서비스 개선(이용 통계 분석, 신규 서비스 개발, <strong>AI 모델 품질 향상</strong>), 마케팅 및 광고(선택 동의 시), 법적 의무 이행을 목적으로 개인정보를 처리했습니다.
                    (이 버전은 "AI 모델 품질 향상"을 목적으로 명시하고 있었는데, 실제로는 자체 모델 학습 파이프라인이 없고 제6조에서 "모델 학습에 사용하지 않음"이라고도 명시하고 있어 문구 간 모순이 있었습니다. 다음 개정에서 삭제되었습니다.)
                  </p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제2조~제5조</h3>
                  <p className="text-gray-700 leading-relaxed">
                    처리하는 개인정보의 항목, 처리 및 보유기간(회원정보·ALT 텍스트 이력·업로드 이미지 탈퇴 후 1년), 제3자 제공, 국내 수탁업체(AWS 서울 리전, 토스페이먼츠, 바로빌) 위탁에 관한 조항은
                    현재 시행 중인{' '}
                    <Link to="/privacy" className="text-primary underline">개인정보 처리방침</Link>
                    {' '}제2조~제5조와 실질적으로 동일합니다.
                  </p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제6조 (개인정보의 국외 이전)</h3>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    회사는 AI 기반 ALT 텍스트 생성 기능 제공을 위해 아래와 같이 개인정보를 국외로 이전했습니다.
                  </p>
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-200 text-xs mt-2">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border border-gray-200 px-3 py-2 text-left">이전받는 자</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">이전 항목</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">이전 국가</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">이용목적 및 보유·이용기간</th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-700">
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">OpenAI, L.L.C.</td>
                          <td className="border border-gray-200 px-3 py-2">업로드·크롤링된 이미지 및 관련 텍스트 콘텐츠</td>
                          <td className="border border-gray-200 px-3 py-2">미국</td>
                          <td className="border border-gray-200 px-3 py-2">AI 이미지 분석 및 ALT 텍스트 생성(주 엔진); 처리 완료 즉시 삭제 (OpenAI 정책 준수, 모델 학습 미사용)</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">Google LLC</td>
                          <td className="border border-gray-200 px-3 py-2">업로드·크롤링된 이미지 및 관련 텍스트 콘텐츠</td>
                          <td className="border border-gray-200 px-3 py-2">미국</td>
                          <td className="border border-gray-200 px-3 py-2">AI 이미지 분석(보조 엔진, fallback); 처리 완료 즉시 삭제 (Google 정책 준수, 모델 학습 미사용)</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">Microsoft Corporation</td>
                          <td className="border border-gray-200 px-3 py-2">업로드·크롤링된 이미지 및 관련 텍스트 콘텐츠</td>
                          <td className="border border-gray-200 px-3 py-2">미국</td>
                          <td className="border border-gray-200 px-3 py-2">AI 이미지 분석(보조 엔진, fallback); 처리 완료 즉시 삭제 (Azure 정책 준수, 모델 학습 미사용)</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p className="text-gray-600 mt-2 text-xs">
                    이 버전의 표는 Azure Translator·Google Translate를 통한 캡션 번역 데이터 흐름을 별도로 기재하지 않았고, "처리 완료 즉시 삭제"라고 표현했으나 실제로는 OpenAI/Azure의 기본 정책(Zero Data Retention 미적용 시 어뷰징 모니터링 목적 최대 30일 보관)과 차이가 있었습니다. 다음 개정에서 바로잡았습니다.
                  </p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제7조 (이용자의 권리의무 및 행사방법)</h3>
                  <p className="text-gray-700 leading-relaxed">
                    "이용자는 개인정보 보호법 시행령 제41조에 따른 서면, 이메일 등의 방법으로 권리 행사를 할 수 있으며, 회사는 이에 대해 10일 이내에 조치 결과를 통지합니다"라고 열람·정정·삭제·처리정지 요구를 구분 없이 일괄 기재했습니다.
                    (처리정지 요구는 개인정보 보호법 제37조상 "지체 없이"가 기준이라 10일 이내로 일괄 표기하는 건 정확하지 않았습니다. 다음 개정에서 권리별로 구분했습니다.)
                  </p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제8조·제9조</h3>
                  <p className="text-gray-700 leading-relaxed">
                    개인정보의 파기, 안전성 확보조치에 관한 조항은 현재 시행 중인 개인정보 처리방침 제8조·제9조와 실질적으로 동일합니다.
                  </p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제10조 (인증 토큰 및 세션 관리)</h3>
                  <p className="text-gray-700 leading-relaxed">
                    이 버전은 JWT 방식 사용 여부, 토큰 저장 위치(로컬 스토리지/메모리), Authorization 헤더 방식 등 구체적인 기술 구현 정보를 명시하고 있었습니다.
                    법적으로 요구되는 내용이 아니고 공격 표면 힌트가 될 수 있어, 다음 개정에서 세션 만료 시간 등 이용자에게 실질적으로 의미 있는 정보 위주로 간소화했습니다.
                  </p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제11조~제13조</h3>
                  <p className="text-gray-700 leading-relaxed">
                    개인정보 보호책임자, 처리방침의 변경, 권익침해 구제방법에 관한 조항은 현재 시행 중인 개인정보 처리방침 제11조~제13조와 실질적으로 동일합니다.
                  </p>
                </section>

                <div className="pt-4 border-t mt-6 space-y-1">
                  <p className="text-gray-600 text-xs">공고일자: 2026년 3월 27일</p>
                  <p className="text-gray-600 text-xs">시행일자: 2026년 4월 1일</p>
                  <p className="text-gray-600 text-xs">개정일자: 2026년 7월 24일 (개인정보 처리위탁 업체에 토스페이먼츠·바로빌 추가)</p>
                  <p className="text-gray-600 text-xs">개정일자: 2026년 7월 26일 (국외 이전 조항을 위탁 조항에서 분리·신설, AWS 국내 서버 명시, 관리자 접속기록 보관기간을 2년으로 명시)</p>
                </div>
              </div>
            </details>

            <details className="border rounded-lg p-4">
              <summary className="cursor-pointer font-semibold text-gray-800">
                제2판 (개정일자: 2026년 7월 24일 ~ 2026년 7월 25일)
              </summary>
              <p className="text-xs text-gray-500 mt-2 mb-4">
                개인정보 처리위탁 업체에 토스페이먼츠·바로빌이 추가된 버전입니다.
                2026년 7월 26일 개정(국외 이전 조항을 위탁 조항에서 분리·신설, AWS 국내 서버 명시, 관리자 접속기록 보관기간을 2년으로 명시)으로 효력을 상실했습니다.
              </p>

              <div className="space-y-6 text-sm">
                <p className="text-gray-700 leading-relaxed">
                  지호아이앤씨(이하 "회사")은 ALT Generation 서비스와 관련하여 「개인정보 보호법」 및 관계 법령에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속원활하게 처리하기 위하여 다음과 같이 개인정보 처리방침을 수립공개합니다.
                </p>

                <section>
                  <h3 className="font-bold text-base mb-2">제1조 (개인정보의 처리 목적)</h3>
                  <p className="text-gray-700 leading-relaxed mb-2">회사는 다음의 목적을 위해 개인정보를 처리합니다. 처리된 개인정보는 아래 목적 이외의 용도로 이용되지 않으며, 목적이 변경되는 경우 별도 동의를 받습니다.</p>
                  <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                    <li>회원 가입 및 관리: 본인 식별인증, 회원자격 유지관리, 부정이용 방지, 고지통지, 고충 처리</li>
                    <li>서비스 제공: ALT 텍스트 생성 서비스(웹 크롤링, URL 분석, 이미지 업로드), API 서비스 제공, 요금 결제 및 정산</li>
                    <li>서비스 개선: 이용 통계 분석, 신규 서비스 개발, AI 모델 품질 향상</li>
                    <li>마케팅 및 광고 (선택 동의 시): 이벤트프로모션 안내, 신규 기능 소식 전달</li>
                    <li>법적 의무 이행: 전자상거래법 등 관계 법령에 따른 기록 보관</li>
                  </ol>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제2조 (처리하는 개인정보의 항목)</h3>
                  <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                    <li>회원가입 시 필수항목: 로그인 아이디, 비밀번호(BCrypt 암호화 저장), 이름, 이메일 주소</li>
                    <li>회원가입 시 선택항목: 휴대전화번호, 회사명, 사업자번호</li>
                    <li>소셜 로그인 시 수집 항목: Google/네이버/카카오 로그인 시 각 사업자가 제공하는 이메일, 이름(또는 닉네임)</li>
                    <li>서비스 이용 시 자동 수집 항목: 접속 IP, 브라우저/OS 정보, 방문 일시, 로그인 세션 정보, ALT 텍스트 생성 이력, API 호출 기록, 크롤링 대상 URL 및 메타데이터, 컨텍스트 프로필 설정, API 인증 정보</li>
                    <li>이미지 업로드 시: 이용자가 업로드한 이미지 파일은 이용자가 직접 삭제하거나 회원 탈퇴 시 삭제됩니다. 생성된 ALT 텍스트 결과물은 이용자 삭제 요청 시 또는 탈퇴 후 1년 보존 기간 경과 후 삭제됩니다.</li>
                  </ol>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제3조 (개인정보의 처리 및 보유기간)</h3>
                  <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                    <li>회원정보: 탈퇴 후 1년간 보존 후 자동 삭제 (탈퇴 취소·복구 목적)</li>
                    <li>ALT 텍스트 생성 이력: 이용자 삭제 요청 시 즉시 삭제, 회원 탈퇴 시 탈퇴 후 1년간 보존 후 자동 삭제</li>
                    <li>업로드 이미지 파일: 이용자 직접 삭제 또는 탈퇴 후 1년 보존 기간 경과 후 삭제</li>
                    <li>로그인 세션 정보: 세션 만료 후 자동 삭제 (기본 30분 비활성 시 만료)</li>
                    <li>감사 로그(보안 이용 기록): 회원 탈퇴 후 1년 또는 관계 법령에 따른 보존기간</li>
                    <li>결제거래 기록: 전자상거래법에 따라 5년 / 소비자 불만분쟁 기록: 3년 / 접속 로그: 통신비밀보호법에 따라 3개월</li>
                  </ol>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제4조 (개인정보의 제3자 제공)</h3>
                  <p className="text-gray-700 leading-relaxed">회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않으며, 이용자 사전 동의, 법령 규정, 생명·신체·재산 보호를 위해 긴급히 필요한 경우에만 예외적으로 제공합니다.</p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제5조 (개인정보 처리의 위탁)</h3>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    회사는 서비스 제공을 위해 아래와 같이 개인정보 처리를 위탁하고 있으며, 위탁계약 시 개인정보가 안전하게 관리되도록 필요한 사항을 규정합니다. (당시 이 조항에는 국외 이전 관련 사항도 함께 포함되어 있었으며, 이후 07/26 개정으로 국외 이전 조항이 별도 제6조로 분리되었습니다.)
                  </p>
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-200 text-xs mt-2">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border border-gray-200 px-3 py-2 text-left">수탁업체</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">위탁 업무</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">보유이용기간</th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-700">
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">Amazon Web Services (AWS)</td>
                          <td className="border border-gray-200 px-3 py-2">서버 호스팅, 데이터 저장</td>
                          <td className="border border-gray-200 px-3 py-2">이용계약 종료 시까지</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">OpenAI (미국)</td>
                          <td className="border border-gray-200 px-3 py-2">AI 이미지 분석 및 ALT 텍스트 생성 (주)</td>
                          <td className="border border-gray-200 px-3 py-2">처리 완료 즉시 삭제 (OpenAI 정책 준수)</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">Google LLC (미국)</td>
                          <td className="border border-gray-200 px-3 py-2">AI 이미지 분석 (보조)</td>
                          <td className="border border-gray-200 px-3 py-2">처리 완료 즉시 삭제 (Google 정책 준수)</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">Microsoft Azure (미국)</td>
                          <td className="border border-gray-200 px-3 py-2">AI 이미지 분석 (보조)</td>
                          <td className="border border-gray-200 px-3 py-2">처리 완료 즉시 삭제 (Azure 정책 준수)</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">토스페이먼츠(주)</td>
                          <td className="border border-gray-200 px-3 py-2">카드 결제 및 자동(정기)결제 대행, 결제 정보 처리</td>
                          <td className="border border-gray-200 px-3 py-2">회원 탈퇴 또는 위탁계약 종료 시까지</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">바로빌</td>
                          <td className="border border-gray-200 px-3 py-2">전자세금계산서·현금영수증 발행 대행</td>
                          <td className="border border-gray-200 px-3 py-2">관계 법령에 따른 보존기간까지</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제6조~제12조</h3>
                  <p className="text-gray-700 leading-relaxed">
                    이용자의 권리·의무 및 행사방법, 개인정보의 파기, 안전성 확보조치, 인증 토큰 및 세션 관리, 개인정보 보호책임자, 처리방침의 변경, 권익침해 구제방법에 관한 조항은
                    현재 시행 중인{' '}
                    <Link to="/privacy" className="text-primary underline">개인정보 처리방침</Link>
                    {' '}제7조~제13조와 실질적으로 동일합니다.
                  </p>
                </section>

                <div className="pt-4 border-t mt-6 space-y-1">
                  <p className="text-gray-600 text-xs">공고일자: 2026년 3월 27일</p>
                  <p className="text-gray-600 text-xs">시행일자: 2026년 4월 1일</p>
                  <p className="text-gray-600 text-xs">개정일자: 2026년 7월 24일 (개인정보 처리위탁 업체에 토스페이먼츠·바로빌 추가)</p>
                </div>
              </div>
            </details>

            <details className="border rounded-lg p-4" open>
              <summary className="cursor-pointer font-semibold text-gray-800">
                제1판 (공고일자: 2026년 3월 27일 / 시행일자: 2026년 4월 1일 ~ 2026년 7월 23일)
              </summary>
              <p className="text-xs text-gray-500 mt-2 mb-4">
                최초 시행 버전입니다. 2026년 7월 24일 개정(처리위탁 업체 추가)으로 효력을 상실했습니다.
              </p>

              <div className="space-y-6 text-sm">
                <p className="text-gray-700 leading-relaxed">
                  지호아이앤씨(이하 "회사")은 ALT Generation 서비스와 관련하여 「개인정보 보호법」 및 관계 법령에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속원활하게 처리하기 위하여 다음과 같이 개인정보 처리방침을 수립공개합니다.
                </p>

                <section>
                  <h3 className="font-bold text-base mb-2">제1조~제4조</h3>
                  <p className="text-gray-700 leading-relaxed">
                    개인정보의 처리 목적, 처리하는 개인정보의 항목, 처리 및 보유기간, 제3자 제공에 관한 조항은 위 제2판과 동일합니다.
                  </p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제5조 (개인정보 처리의 위탁)</h3>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    회사는 서비스 제공을 위해 아래와 같이 개인정보 처리를 위탁하고 있으며, 위탁계약 시 개인정보가 안전하게 관리되도록 필요한 사항을 규정합니다.
                  </p>
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-200 text-xs mt-2">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border border-gray-200 px-3 py-2 text-left">수탁업체</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">위탁 업무</th>
                          <th className="border border-gray-200 px-3 py-2 text-left">보유이용기간</th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-700">
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">Amazon Web Services (AWS)</td>
                          <td className="border border-gray-200 px-3 py-2">서버 호스팅, 데이터 저장</td>
                          <td className="border border-gray-200 px-3 py-2">이용계약 종료 시까지</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">OpenAI (미국)</td>
                          <td className="border border-gray-200 px-3 py-2">AI 이미지 분석 및 ALT 텍스트 생성 (주)</td>
                          <td className="border border-gray-200 px-3 py-2">처리 완료 즉시 삭제 (OpenAI 정책 준수)</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">Google LLC (미국)</td>
                          <td className="border border-gray-200 px-3 py-2">AI 이미지 분석 (보조)</td>
                          <td className="border border-gray-200 px-3 py-2">처리 완료 즉시 삭제 (Google 정책 준수)</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-200 px-3 py-2">Microsoft Azure (미국)</td>
                          <td className="border border-gray-200 px-3 py-2">AI 이미지 분석 (보조)</td>
                          <td className="border border-gray-200 px-3 py-2">처리 완료 즉시 삭제 (Azure 정책 준수)</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p className="text-gray-600 mt-2 text-xs">
                    이 버전에는 토스페이먼츠·바로빌 위탁 항목이 없습니다(당시 카드 자동결제·전자세금계산서 기능이 아직 운영되지 않았습니다).
                  </p>
                </section>

                <section>
                  <h3 className="font-bold text-base mb-2">제6조~제12조</h3>
                  <p className="text-gray-700 leading-relaxed">
                    이용자의 권리·의무 및 행사방법, 개인정보의 파기, 안전성 확보조치, 인증 토큰 및 세션 관리, 개인정보 보호책임자, 처리방침의 변경, 권익침해 구제방법에 관한 조항은 위 제2판과 동일합니다.
                  </p>
                </section>

                <div className="pt-4 border-t mt-6 space-y-1">
                  <p className="text-gray-600 text-xs">공고일자: 2026년 3월 27일</p>
                  <p className="text-gray-600 text-xs">시행일자: 2026년 4월 1일</p>
                </div>
              </div>
            </details>
          </div>

          <div className="mt-8 pt-4 border-t text-xs text-gray-500">
            <Link to="/privacy" className="text-primary underline">현재 개인정보 처리방침으로 돌아가기</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
